

<div class="agreement_body">
    <div class="heading">
        <h3>Find Agreement Number</h3>
        <span (click)="closeDialog()" class="close">
            <mat-icon>close</mat-icon>
        </span>
    </div>
    <div class="formwrap">
        <div>
            <form [formGroup]="searchByForm">
                <div class="fieldwrap">
                    <select formControlName="searchBy">
                        <option value="">Please select an option</option>
                        <option value="phoneNumber">Phone Number</option>
                        <option value="emailAddress">Email Address</option>
                    </select>
                    <mat-error *ngIf="searchByForm.controls['searchBy'].touched && searchByForm.controls['searchBy'].hasError('required')">
                        This is required.
                    </mat-error>
                </div>
                <div class="fieldwrap">
                    <ng-container *ngIf="searchByForm.value.searchBy === 'phoneNumber'">
                        <input type="text" placeholder="Enter Phone number" formControlName="phoneNumber" mask="(000) 000-0000">
                        <mat-error *ngIf="searchByForm.controls['phoneNumber'].touched && searchByForm.controls['phoneNumber'].hasError('required')">
                            This is required.
                        </mat-error>
                        <mat-error *ngIf="searchByForm.controls['phoneNumber'].touched && searchByForm.controls['phoneNumber'].hasError('pattern')">
                            Enter Valid Phone number.
                        </mat-error>
                    </ng-container>
                    <ng-container *ngIf="searchByForm.value.searchBy === 'emailAddress'">
                        <input type="text" placeholder="Enter Email Address" formControlName="emailAddress" (keyup)="changeEmailAndSet()">
                        <mat-error *ngIf="searchByForm.controls['emailAddress'].touched && searchByForm.controls['emailAddress'].hasError('required')">
                            This is required.
                        </mat-error>
                        <mat-error *ngIf="searchByForm.controls['emailAddress'].touched && searchByForm.controls['emailAddress'].hasError('pattern')">
                            Enter Valid email address.
                        </mat-error>
                    </ng-container>
                </div>
                <div class="btnprt"> 
                    <button (click)="getAgreementdata()">Search</button>
                </div>
            </form>
        </div>
    
        <div *ngIf="showAgreementForm" class="showprt">
            <form [formGroup]="agreementNumberForm">
                <div class="fieldwrap">
                    <select formControlName="serviceAgreementNumber">
                        <option value="">Select your agreement number</option>
                        <option *ngFor="let item of serviceAgreement" [value]="item.agreementNumber">{{item?.agreementNumber}}</option>
                    </select>
                    <mat-error *ngIf="agreementNumberForm.controls['serviceAgreementNumber'].touched && agreementNumberForm.controls['serviceAgreementNumber'].hasError('required')">
                        This is required.
                    </mat-error>
                </div>
                <div class="btnprt">
                    <button (click)="getParticularAgreementData()">Submit</button>
                </div>
                
            </form>
        </div>
    </div>
</div>
<!-- <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button>
</mat-dialog-actions> -->
